import { useMemo } from "react";

import { isCollapsedRunSelection } from "@/components/tiptap/collapse/blockCollapse";
import { useFeatureFlag } from "@/utils/useFeatureFlag";

import type { SuggestionProviderType } from "@/components/suggestions/types";
import type { DocumentModel } from "@/models/DocumentModel";

export function useAcceptedProviders(
  accept: SuggestionProviderType[] | undefined,
  doc: DocumentModel,
): SuggestionProviderType[] | undefined {
  const computedNodesEnabled = useFeatureFlag("computed-nodes");

  // The right-clicked node, when there is one, is what the menu acts on.
  const targetNode = doc.editor.suggestions.pointerNode ?? doc.selection.topSelectedNode;

  const { tiptap } = doc.editor;
  const isCollapsedRun = !!tiptap && isCollapsedRunSelection(tiptap.view, tiptap.state.selection);

  return useMemo(() => {
    if (isCollapsedRun) {
      return ["collapseBlock"];
    }

    if (!computedNodesEnabled) {
      return accept?.filter((a) => a !== "computed");
    }

    let filteredAccept = accept;

    if (targetNode?.type === "computedResult") {
      filteredAccept = ["computedCommand", "clipboardCommand"];
    }

    return filteredAccept;
  }, [accept, computedNodesEnabled, targetNode, isCollapsedRun]);
}
